<template>
  <div
    v-if="flow"
    class="d-flex flex-column ga-6"
    :class="wrapperClass"
  >
    <ApprovalFlowStage
      v-for="stage in flow.stages"
      :key="`${flow.ulid}-${stage.stage_number}`"
      :stage="stage"
      mode="view"
    />
  </div>
</template>

<script setup>
import ApprovalFlowStage from '@/components/jobProfiles/editor/approvals/ApprovalFlowStage.vue';

defineProps({
  flow: {
    type: Object,
    default: null,
  },
  wrapperClass: {
    type: String,
    default: '',
  },
});
</script>
